module.exports = __webpack_public_path__ + "static/media/RI-D4-0.4-081.cfa45802.webp";